import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const prevPathnameRef = useRef(pathname);

    useEffect(() => {
        // Only scroll to top if this is a navigation (not a refresh)
        // We detect refresh by checking if the pathname actually changed
        if (prevPathnameRef.current !== pathname) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
        
        // Update the previous pathname for next comparison
        prevPathnameRef.current = pathname;
    }, [pathname]);

    return null;
};

export default ScrollToTop;